import React from 'react'

const WriteReviewForm = () => {
    return (
        <div className='my-4 md:pr-2'>
            <form action="" className='flex flex-col space-y-4 w-full '>
                <input type="text" name="" id="" className='focus:border-primary-base focus:ring-primary-base rounded-sm' placeholder='Which place have you visited with us?' />
                <input type="text" name="" id="" className='focus:border-primary-base focus:ring-primary-base rounded-sm' placeholder='Your details (name/address)' />
                <textarea name="" id="" cols={1} rows={6} className='focus:border-primary-base focus:ring-primary-base rounded-sm' placeholder='Write your review, rating here......'></textarea>

                <input type="submit" value="Submit" className='bg-primary-base px-3 py-2 text-white rounded-md' />
            </form>
        </div>
    )
}

export default WriteReviewForm